module.exports = __webpack_public_path__ + "img/ic_gold.1c43d241.png";